import React, {useRef, useContext} from 'react';
import {Card, ListGroup, Dropdown} from 'react-bootstrap';
import {MDBCheckbox} from 'mdb-react-ui-kit';
import { updateCheckinExtra } from '../../../../services/MadricService';
import { MadricContext } from '../../../../Context/MadricContext';
import Graph from './Graph';


/**
 *  L'accueil
 * @param {*} props props
 * @return {JSX}
 */
function Checkin(props) {

  const {projectInfo, setProjectInfo} = useContext(MadricContext);
  
  const extra = useRef({
    extra1: props.checkin.extra1,
    extra2: props.checkin.extra2,
    extra3: props.checkin.extra3
  });

 /**
 * Permet de modifier les extras
 * @param {*} event event
 */
 async function handleChangeExtra(event) {
  extra.current = {
    ...extra.current,
    [event.target.name]: event.target.checked,
  };


  const updatedCheckin = projectInfo.map((p) => {
    if (p.id === props.checkin.id && p.type === 'checkin') {
      return {
        ...p,
        extra1: extra.current.extra1,
        extra2: extra.current.extra2,
        extra3: extra.current.extra3

      };
    }
    return p;
  });
  setProjectInfo(updatedCheckin);
  await updateCheckinExtra(props.checkin.id, extra.current);
}

const windowWidth = window.innerWidth;
const isMobile = windowWidth <= 600;

  return (
    <div className="checkin-container" key={props.checkin.id}>
      <Card className="checkin-card">
        <Card.Header className="checkin-header">
          <span style={{fontWeight: 'bold', textDecoration: 'underline'}}>CHECK-IN {isMobile ? <br /> : ""} </span> {props.formatDate(props.checkin.date)}
        </Card.Header>
        <ListGroup variant="flush">
          <ListGroup.Item className="checkin-list-item">
            Employé: {props.checkin.user_name}
          </ListGroup.Item>
          <ListGroup.Item
            className="checkin-list-item"
            style={{
              backgroundColor:
              props.checkin.from === null || props.checkin.to === null ? 'red' : 'white',
            }}
          >
            Heure: {props.checkin.from === null ? '-' : props.checkin.from} à{' '}
            {props.checkin.to === null ? '-' : props.checkin.to}
          </ListGroup.Item>
          <ListGroup.Item className="checkin-list-item">
            Transport: {props.checkin.transport === 1 ? 'Oui' : 'Non'}
          </ListGroup.Item>
          <ListGroup.Item className="checkin-list-item">
            Travaillé avec:
            {props.checkin.work_with.length === 0 ? (
              ' Aucun employé'
            ) : (
              <Dropdown>
                <Dropdown.Toggle
                  className="chantierheure-dropdown"
                  style={{
                    all: 'unset',
                    backgroundColor: 'white',
                    color: 'black',
                    cursor: 'pointer',
                  }}
                >
                  {props.checkin.work_with[0].label}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {props.checkin.work_with.map((w, index) => {
                    return <Dropdown.Item key={index}>{w.label}</Dropdown.Item>;
                  })}
                </Dropdown.Menu>
              </Dropdown>
            )}
          </ListGroup.Item>
          <ListGroup.Item>
            <MDBCheckbox
              name="extra1"
              id="inlineCheckbox111"
              defaultChecked={props.checkin.extra1}
              label="Extra possible"
              onChange={handleChangeExtra}
              inline
            />
            {localStorage.getItem('admin') === '1' ? (
              <React.Fragment>
                <MDBCheckbox
                  name="extra2"
                  id="inlineCheckbox222"
                  defaultChecked={props.checkin.extra2}
                  label="Extra valider"
                  onChange={handleChangeExtra}
                  inline
                />
                <MDBCheckbox
                  name="extra3"
                  id="inlineCheckbox333"
                  defaultChecked={props.checkin.extra3}
                  label="Extra confirmer"
                  onChange={handleChangeExtra}
                  inline
                />
              </React.Fragment>
            ) : (
              ' '
            )}
          </ListGroup.Item>
          <ListGroup.Item className="checkin-list-item">
            Note: {props.checkin.note}
          </ListGroup.Item>
        </ListGroup>
        {props.checkedGraph ? props.checkin.taches.length !== 0 ? <Card.Body> <Graph taches={props.checkin.taches}/></Card.Body>  : '' : ''}
      </Card>
    </div>
  );
}

export default Checkin;
